import { utils } from '@desygner/ui-common-components';

export const PRESETS = {
  formMinWidth: utils.rem(320),
  formMaxWidth: utils.rem(420),
  authImageWidthRem: utils.rem(425),
  authImageHeightRem: utils.rem(600),
  authImageWidthPx: utils.rem(425),
  authImageHeightPx: utils.rem(600),
  modalMaxWidth: utils.rem(848),
  backIconTopOffset: utils.rem(4),
  authModalMaxHeight: utils.rem(600),
  checkboxWorkaroundMargin: utils.rem(22),
  checkboxWorkaroundTranslateY: utils.rem(-10),
};
